import React, { useEffect, useState } from "react";

// icon
import EpicImg from "../../../assets/images/EpicImg.svg";
import EpicImgSm from "../../../assets/images/EpicImgSm.svg";

// route
import { Link, useLocation } from "react-router-dom";

// store
import { useDispatch, useSelector } from "react-redux";
import { setViewData } from "../../../reducer/slices/twilio-calls/view-slice";

// component
import ConversationItem from "./conversation-item";
import { NotificationToast } from "../header/Notification/NotificationToast";

// notification library
import * as signalR from "@microsoft/signalr";

// endpoints
import { ENDPOINTS } from "../../../js/api/_config";
import { fetchUnreadCount } from "../../../reducer/slices/notifications/unread-count";

const Leftbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [notifyMessage, setNotifyMessage] = useState({
    message: "",
    type: "",
  });
  const [showNotify, setShowNotify] = useState(false);
  const callView = useSelector((state) => state.callView.callSizeData);
  const location = useLocation();
  const isCallInprogress = useSelector((state) => state.call.callData);
  const callViewSize = useSelector((state) => state.callView.callSizeData);
  const dispatch = useDispatch();
  const routeName = location.pathname.split("/").filter(Boolean).pop();
  const user = useSelector((state) => state.user);
  const { token, userProfile, role } = user;
  const notify_unread_count = useSelector((state) => state.notify_unread_count);
  const { counts, loading } = notify_unread_count;

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    window.location.href = "/login";
  };

  const [tooltipVisibility, setTooltipVisibility] = useState({});

  const minimizeCall = () => {
    if (isCallInprogress && !callView.isMinView)
      dispatch(
        setViewData({
          isMaxView: true,
          isMinView: true,
        })
      );
  };

  const dashboardIconSvg = (
    <svg
      width="28"
      height="28"
      className="float"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99609 24.3757C11.0003 24.5 12.2746 24.5 14 24.5C15.7254 24.5 16.9997 24.5 18.0039 24.3757M9.99609 24.3757C9.07993 24.2623 8.38858 24.0454 7.78457 23.6306C7.683 23.5608 7.58398 23.4873 7.48769 23.4101C6.28737 22.4482 5.77756 20.8446 4.75793 17.6375C3.7383 14.4304 3.22849 12.8268 3.64634 11.3276C3.67986 11.2073 3.71768 11.0883 3.75974 10.9709C4.28395 9.50694 5.61866 8.51588 8.28809 6.53377C10.9575 4.55165 12.2922 3.56059 13.8165 3.50344C13.9388 3.49885 14.0612 3.49885 14.1835 3.50344C15.7078 3.56059 17.0425 4.55165 19.7119 6.53377C22.3813 8.51588 23.716 9.50694 24.2403 10.9709C24.2823 11.0883 24.3201 11.2073 24.3537 11.3276C24.7715 12.8268 24.2617 14.4304 23.2421 17.6375C22.2224 20.8446 21.7126 22.4482 20.5123 23.4101C20.416 23.4873 20.317 23.5608 20.2154 23.6306C19.6114 24.0454 18.9201 24.2623 18.0039 24.3757M9.99609 24.3757V24.287V20.7065C9.99609 18.4466 11.7887 16.6145 14 16.6145C16.2113 16.6145 18.0039 18.4466 18.0039 20.7065V24.287V24.3757"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );

  const trialIconSvg = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2235 15.8978L10.4177 15.1733L10.2235 15.8978ZM8.10222 13.7765L8.82667 13.5823L8.10222 13.7765ZM15.8978 13.7765L15.1733 13.5823L15.8978 13.7765ZM13.7765 15.8978L13.5823 15.1733L13.7765 15.8978ZM13.7765 8.10222L13.5823 8.82667L13.7765 8.10222ZM15.8978 10.2235L15.1733 10.4177L15.8978 10.2235ZM10.2235 8.10222L10.4177 8.82667L10.2235 8.10222ZM8.10222 10.2235L8.82667 10.4177L8.10222 10.2235ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM12 2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2.75ZM12 15.25C11.0217 15.25 10.6797 15.2436 10.4177 15.1733L10.0294 16.6222C10.5303 16.7564 11.1183 16.75 12 16.75V15.25ZM7.25 12C7.25 12.8817 7.24356 13.4697 7.37778 13.9706L8.82667 13.5823C8.75644 13.3203 8.75 12.9783 8.75 12H7.25ZM10.4177 15.1733C9.6412 14.9653 9.03472 14.3588 8.82667 13.5823L7.37778 13.9706C7.72453 15.2647 8.73533 16.2755 10.0294 16.6222L10.4177 15.1733ZM15.25 12C15.25 12.9783 15.2436 13.3203 15.1733 13.5823L16.6222 13.9706C16.7564 13.4697 16.75 12.8817 16.75 12H15.25ZM12 16.75C12.8817 16.75 13.4697 16.7564 13.9706 16.6222L13.5823 15.1733C13.3203 15.2436 12.9783 15.25 12 15.25V16.75ZM15.1733 13.5823C14.9653 14.3588 14.3588 14.9653 13.5823 15.1733L13.9706 16.6222C15.2647 16.2755 16.2755 15.2647 16.6222 13.9706L15.1733 13.5823ZM12 8.75C12.9783 8.75 13.3203 8.75644 13.5823 8.82667L13.9706 7.37778C13.4697 7.24356 12.8817 7.25 12 7.25V8.75ZM16.75 12C16.75 11.1183 16.7564 10.5303 16.6222 10.0294L15.1733 10.4177C15.2436 10.6797 15.25 11.0217 15.25 12H16.75ZM13.5823 8.82667C14.3588 9.03472 14.9653 9.6412 15.1733 10.4177L16.6222 10.0294C16.2755 8.73533 15.2647 7.72453 13.9706 7.37778L13.5823 8.82667ZM12 7.25C11.1183 7.25 10.5303 7.24356 10.0294 7.37778L10.4177 8.82667C10.6797 8.75644 11.0217 8.75 12 8.75V7.25ZM8.75 12C8.75 11.0217 8.75644 10.6797 8.82667 10.4177L7.37778 10.0294C7.24356 10.5303 7.25 11.1183 7.25 12H8.75ZM10.0294 7.37778C8.73533 7.72453 7.72453 8.73533 7.37778 10.0294L8.82667 10.4177C9.03472 9.6412 9.6412 9.03472 10.4177 8.82667L10.0294 7.37778Z"
        fill="white"
      />
    </svg>
  );

  const patientIconSvg = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const conversationIconSvg = (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.75L6 7.75C5.58579 7.75 5.25 7.41421 5.25 7C5.25 6.58579 5.58579 6.25 6 6.25L10 6.25C10.4142 6.25 10.75 6.58579 10.75 7C10.75 7.41421 10.4142 7.75 10 7.75Z"
        fill="white"
      />
      <path
        d="M5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H14C14.4142 10.25 14.75 10.5858 14.75 11C14.75 11.4142 14.4142 11.75 14 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.96644 0.25H11.0336C12.4053 0.249995 13.4807 0.249992 14.3451 0.320612C15.2252 0.392522 15.9523 0.541379 16.6104 0.876713C17.6924 1.42798 18.572 2.30762 19.1233 3.38955C19.4586 4.04769 19.6075 4.77479 19.6794 5.65494C19.75 6.51928 19.75 7.59471 19.75 8.96642V11.7232C19.75 11.9797 19.75 12.1358 19.7436 12.2719C19.6033 15.2338 17.2338 17.6033 14.2719 17.7436C14.1358 17.75 13.9639 17.75 13.6788 17.75H13.6504L13.5751 17.7501C12.7079 17.7556 11.8632 18.0264 11.1543 18.5259L11.1051 18.5609L8.49441 20.4257C6.9899 21.5003 5.01288 19.9484 5.69954 18.2317C5.79183 18.001 5.62191 17.75 5.37341 17.75H4.77166C2.27441 17.75 0.25 15.7256 0.25 13.2283L0.25 8.96644C0.249995 7.59472 0.249992 6.51929 0.320612 5.65494C0.392522 4.77479 0.541379 4.04769 0.876713 3.38955C1.42798 2.30762 2.30762 1.42798 3.38955 0.876713C4.04769 0.541379 4.77479 0.392522 5.65494 0.320612C6.51929 0.249992 7.59472 0.249995 8.96644 0.25ZM5.77708 1.81563C4.9897 1.87996 4.48197 2.00359 4.07054 2.21322C3.27085 2.62068 2.62068 3.27085 2.21322 4.07054C2.00359 4.48197 1.87996 4.9897 1.81563 5.77708C1.75058 6.57322 1.75 7.58749 1.75 9V13.2283C1.75 14.8972 3.10284 16.25 4.77166 16.25H5.37341C6.68311 16.25 7.57867 17.5728 7.09226 18.7888C6.96197 19.1145 7.33709 19.409 7.62255 19.2051L10.2333 17.3403L10.2902 17.2997C11.2493 16.6239 12.3922 16.2576 13.5655 16.2501L13.6504 16.25C13.9721 16.25 14.1053 16.2498 14.201 16.2452C16.3902 16.1416 18.1416 14.3902 18.2452 12.201C18.2498 12.105 18.25 11.9871 18.25 11.6988V9C18.25 7.58749 18.2494 6.57322 18.1844 5.77708C18.12 4.9897 17.9964 4.48197 17.7868 4.07054C17.3793 3.27085 16.7291 2.62068 15.9295 2.21322C15.518 2.00359 15.0103 1.87996 14.2229 1.81563C13.4268 1.75058 12.4125 1.75 11 1.75H9C7.58749 1.75 6.57322 1.75058 5.77708 1.81563Z"
        fill="white"
      />
    </svg>
  );

  const integrationsIconSvg = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.84776 8.76537L9.15485 8.47835L9.84776 8.76537ZM9.84776 5.23463L9.15485 5.52165L9.84776 5.23463ZM14 6.25C13.5858 6.25 13.25 6.58579 13.25 7C13.25 7.41421 13.5858 7.75 14 7.75V6.25ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM16.25 10C16.25 10.4142 16.5858 10.75 17 10.75C17.4142 10.75 17.75 10.4142 17.75 10H16.25ZM17.75 4C17.75 3.58579 17.4142 3.25 17 3.25C16.5858 3.25 16.25 3.58579 16.25 4H17.75ZM9.84776 18.7654L9.15485 18.4784L9.84776 18.7654ZM9.84776 15.2346L9.15485 15.5216L9.84776 15.2346ZM19.8478 18.7654L19.1549 18.4784L19.8478 18.7654ZM19.8478 15.2346L19.1549 15.5216L19.8478 15.2346ZM7 9.25C6.5238 9.25 6.20421 9.24959 5.95674 9.23271C5.71601 9.21628 5.5988 9.18681 5.52165 9.15485L4.94762 10.5407C5.23801 10.661 5.53754 10.7076 5.85464 10.7292C6.165 10.7504 6.54432 10.75 7 10.75V9.25ZM3.25 7C3.25 7.45568 3.24959 7.835 3.27077 8.14536C3.29241 8.46246 3.33905 8.76199 3.45933 9.05238L4.84515 8.47835C4.81319 8.4012 4.78372 8.28399 4.76729 8.04326C4.75041 7.79579 4.75 7.4762 4.75 7H3.25ZM5.52165 9.15485C5.21536 9.02798 4.97202 8.78464 4.84515 8.47835L3.45933 9.05238C3.73844 9.72621 4.27379 10.2616 4.94762 10.5407L5.52165 9.15485ZM9.25 7C9.25 7.4762 9.24959 7.79579 9.23271 8.04326C9.21628 8.28399 9.18681 8.4012 9.15485 8.47835L10.5407 9.05238C10.661 8.76199 10.7076 8.46246 10.7292 8.14536C10.7504 7.835 10.75 7.45568 10.75 7H9.25ZM7 10.75C7.45568 10.75 7.835 10.7504 8.14536 10.7292C8.46246 10.7076 8.76199 10.661 9.05238 10.5407L8.47835 9.15485C8.4012 9.18681 8.28399 9.21628 8.04326 9.23271C7.79579 9.24959 7.4762 9.25 7 9.25V10.75ZM9.15485 8.47835C9.02798 8.78464 8.78464 9.02798 8.47835 9.15485L9.05238 10.5407C9.72621 10.2616 10.2616 9.72621 10.5407 9.05238L9.15485 8.47835ZM7 4.75C7.4762 4.75 7.79579 4.75041 8.04326 4.76729C8.28399 4.78372 8.4012 4.81319 8.47835 4.84515L9.05238 3.45933C8.76199 3.33905 8.46246 3.29241 8.14536 3.27077C7.835 3.24959 7.45568 3.25 7 3.25V4.75ZM10.75 7C10.75 6.54432 10.7504 6.165 10.7292 5.85464C10.7076 5.53754 10.661 5.23801 10.5407 4.94762L9.15485 5.52165C9.18681 5.5988 9.21628 5.71601 9.23271 5.95674C9.24959 6.20421 9.25 6.5238 9.25 7H10.75ZM8.47835 4.84515C8.78464 4.97202 9.02798 5.21536 9.15485 5.52165L10.5407 4.94762C10.2616 4.27379 9.72621 3.73844 9.05238 3.45933L8.47835 4.84515ZM7 3.25C6.54432 3.25 6.165 3.24959 5.85464 3.27077C5.53754 3.29241 5.23801 3.33905 4.94762 3.45933L5.52165 4.84515C5.5988 4.81319 5.71601 4.78372 5.95674 4.76729C6.20421 4.75041 6.5238 4.75 7 4.75V3.25ZM4.75 7C4.75 6.5238 4.75041 6.20421 4.76729 5.95674C4.78372 5.71601 4.81319 5.5988 4.84515 5.52165L3.45933 4.94762C3.33905 5.23801 3.29241 5.53754 3.27077 5.85464C3.24959 6.165 3.25 6.54432 3.25 7H4.75ZM4.94762 3.45933C4.27379 3.73844 3.73844 4.27379 3.45933 4.94762L4.84515 5.52165C4.97202 5.21536 5.21536 4.97202 5.52165 4.84515L4.94762 3.45933ZM14 7.75H20V6.25H14V7.75ZM17.75 10V4H16.25V10H17.75ZM7 19.25C6.5238 19.25 6.20421 19.2496 5.95674 19.2327C5.71601 19.2163 5.5988 19.1868 5.52165 19.1549L4.94762 20.5407C5.23801 20.661 5.53754 20.7076 5.85464 20.7292C6.165 20.7504 6.54432 20.75 7 20.75V19.25ZM3.25 17C3.25 17.4557 3.24959 17.835 3.27077 18.1454C3.29241 18.4625 3.33905 18.762 3.45933 19.0524L4.84515 18.4784C4.81319 18.4012 4.78372 18.284 4.76729 18.0433C4.75041 17.7958 4.75 17.4762 4.75 17H3.25ZM5.52165 19.1549C5.21536 19.028 4.97202 18.7846 4.84515 18.4784L3.45933 19.0524C3.73844 19.7262 4.27379 20.2616 4.94762 20.5407L5.52165 19.1549ZM9.25 17C9.25 17.4762 9.24959 17.7958 9.23271 18.0433C9.21628 18.284 9.18681 18.4012 9.15485 18.4784L10.5407 19.0524C10.661 18.762 10.7076 18.4625 10.7292 18.1454C10.7504 17.835 10.75 17.4557 10.75 17H9.25ZM7 20.75C7.45568 20.75 7.835 20.7504 8.14536 20.7292C8.46246 20.7076 8.76199 20.661 9.05238 20.5407L8.47835 19.1549C8.4012 19.1868 8.28399 19.2163 8.04326 19.2327C7.79579 19.2496 7.4762 19.25 7 19.25V20.75ZM9.15485 18.4784C9.02798 18.7846 8.78464 19.028 8.47835 19.1549L9.05238 20.5407C9.72621 20.2616 10.2616 19.7262 10.5407 19.0524L9.15485 18.4784ZM7 14.75C7.4762 14.75 7.79579 14.7504 8.04326 14.7673C8.28399 14.7837 8.4012 14.8132 8.47835 14.8451L9.05238 13.4593C8.76199 13.339 8.46246 13.2924 8.14536 13.2708C7.835 13.2496 7.45568 13.25 7 13.25V14.75ZM10.75 17C10.75 16.5443 10.7504 16.165 10.7292 15.8546C10.7076 15.5375 10.661 15.238 10.5407 14.9476L9.15485 15.5216C9.18681 15.5988 9.21628 15.716 9.23271 15.9567C9.24959 16.2042 9.25 16.5238 9.25 17H10.75ZM8.47835 14.8451C8.78464 14.972 9.02798 15.2154 9.15485 15.5216L10.5407 14.9476C10.2616 14.2738 9.72621 13.7384 9.05238 13.4593L8.47835 14.8451ZM7 13.25C6.54432 13.25 6.165 13.2496 5.85464 13.2708C5.53754 13.2924 5.23801 13.339 4.94762 13.4593L5.52165 14.8451C5.5988 14.8132 5.71601 14.7837 5.95674 14.7673C6.20421 14.7504 6.5238 14.75 7 14.75V13.25ZM4.75 17C4.75 16.5238 4.75041 16.2042 4.76729 15.9567C4.78372 15.716 4.81319 15.5988 4.84515 15.5216L3.45933 14.9476C3.33905 15.238 3.29241 15.5375 3.27077 15.8546C3.24959 16.165 3.25 16.5443 3.25 17H4.75ZM4.94762 13.4593C4.27379 13.7384 3.73844 14.2738 3.45933 14.9476L4.84515 15.5216C4.97202 15.2154 5.21536 14.972 5.52165 14.8451L4.94762 13.4593ZM17 19.25C16.5238 19.25 16.2042 19.2496 15.9567 19.2327C15.716 19.2163 15.5988 19.1868 15.5216 19.1549L14.9476 20.5407C15.238 20.661 15.5375 20.7076 15.8546 20.7292C16.165 20.7504 16.5443 20.75 17 20.75V19.25ZM13.25 17C13.25 17.4557 13.2496 17.835 13.2708 18.1454C13.2924 18.4625 13.339 18.762 13.4593 19.0524L14.8451 18.4784C14.8132 18.4012 14.7837 18.284 14.7673 18.0433C14.7504 17.7958 14.75 17.4762 14.75 17H13.25ZM15.5216 19.1549C15.2154 19.028 14.972 18.7846 14.8451 18.4784L13.4593 19.0524C13.7384 19.7262 14.2738 20.2616 14.9476 20.5407L15.5216 19.1549ZM19.25 17C19.25 17.4762 19.2496 17.7958 19.2327 18.0433C19.2163 18.284 19.1868 18.4012 19.1549 18.4784L20.5407 19.0524C20.661 18.762 20.7076 18.4625 20.7292 18.1454C20.7504 17.835 20.75 17.4557 20.75 17H19.25ZM17 20.75C17.4557 20.75 17.835 20.7504 18.1454 20.7292C18.4625 20.7076 18.762 20.661 19.0524 20.5407L18.4784 19.1549C18.4012 19.1868 18.284 19.2163 18.0433 19.2327C17.7958 19.2496 17.4762 19.25 17 19.25V20.75ZM19.1549 18.4784C19.028 18.7846 18.7846 19.028 18.4784 19.1549L19.0524 20.5407C19.7262 20.2616 20.2616 19.7262 20.5407 19.0524L19.1549 18.4784ZM17 14.75C17.4762 14.75 17.7958 14.7504 18.0433 14.7673C18.284 14.7837 18.4012 14.8132 18.4784 14.8451L19.0524 13.4593C18.762 13.339 18.4625 13.2924 18.1454 13.2708C17.835 13.2496 17.4557 13.25 17 13.25V14.75ZM20.75 17C20.75 16.5443 20.7504 16.165 20.7292 15.8546C20.7076 15.5375 20.661 15.238 20.5407 14.9476L19.1549 15.5216C19.1868 15.5988 19.2163 15.716 19.2327 15.9567C19.2496 16.2042 19.25 16.5238 19.25 17H20.75ZM18.4784 14.8451C18.7846 14.972 19.028 15.2154 19.1549 15.5216L20.5407 14.9476C20.2616 14.2738 19.7262 13.7384 19.0524 13.4593L18.4784 14.8451ZM17 13.25C16.5443 13.25 16.165 13.2496 15.8546 13.2708C15.5375 13.2924 15.238 13.339 14.9476 13.4593L15.5216 14.8451C15.5988 14.8132 15.716 14.7837 15.9567 14.7673C16.2042 14.7504 16.5238 14.75 17 14.75V13.25ZM14.75 17C14.75 16.5238 14.7504 16.2042 14.7673 15.9567C14.7837 15.716 14.8132 15.5988 14.8451 15.5216L13.4593 14.9476C13.339 15.238 13.2924 15.5375 13.2708 15.8546C13.2496 16.165 13.25 16.5443 13.25 17H14.75ZM14.9476 13.4593C14.2738 13.7384 13.7384 14.2738 13.4593 14.9476L14.8451 15.5216C14.972 15.2154 15.2154 14.972 15.5216 14.8451L14.9476 13.4593Z"
        fill="white"
      />
    </svg>
  );

  const calendarIconSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 0C7.16421 0 7.5 0.335786 7.5 0.75V2.01061C8.16923 2 8.91284 2 9.73894 2H9.76106C10.5872 2 11.3308 2 12 2.01061V0.75C12 0.335786 12.3358 0 12.75 0C13.1642 0 13.5 0.335786 13.5 0.75V2.06358C15.0119 2.15837 16.1734 2.40335 17.1298 3.09815C17.6179 3.45281 18.0472 3.88209 18.4018 4.37023C18.9877 5.17656 19.25 6.12094 19.3763 7.28648C19.5 8.42861 19.5 9.8682 19.5 11.7047V11.7615C19.5 12.9213 19.5 13.9186 19.4706 14.7757C19.4064 16.6491 19.2037 18.0261 18.4018 19.1298C18.0472 19.6179 17.6179 20.0472 17.1298 20.4018C16.0261 21.2037 14.6491 21.4064 12.7757 21.4706C11.9184 21.5 10.921 21.5 9.76079 21.5H9.70473C7.8682 21.5 6.42861 21.5 5.28648 21.3763C4.12094 21.25 3.17656 20.9877 2.37024 20.4018C1.88209 20.0472 1.45281 19.6179 1.09815 19.1298C0.512324 18.3234 0.250006 17.3791 0.123728 16.2135C-1.46478e-05 15.0714 -8.14982e-06 13.6318 1.35225e-07 11.7952V11.7048C-8.14982e-06 9.86821 -1.46478e-05 8.42861 0.123728 7.28648C0.250006 6.12094 0.512324 5.17656 1.09815 4.37023C1.45281 3.88209 1.88209 3.45281 2.37024 3.09815C3.32655 2.40335 4.48808 2.15837 6 2.06358V0.75C6 0.335786 6.33579 0 6.75 0ZM6 3.56725C4.63795 3.66092 3.85177 3.87585 3.25191 4.31168C2.89111 4.57382 2.57382 4.89111 2.31168 5.25191C1.94259 5.75992 1.72745 6.41013 1.615 7.44804C1.50103 8.49999 1.5 9.85843 1.5 11.75C1.5 13.6416 1.50103 15 1.615 16.052C1.72745 17.0899 1.94259 17.7401 2.31168 18.2481C2.57382 18.6089 2.89111 18.9262 3.25191 19.1883C3.75992 19.5574 4.41013 19.7725 5.44805 19.885C6.49999 19.999 7.85843 20 9.75 20C10.5983 20 11.3418 19.9999 12.0018 19.9892C12.0062 19.5145 12.021 19.1651 12.0708 18.8505C12.4605 16.3901 14.3901 14.4605 16.8505 14.0708C17.1651 14.021 17.5145 14.0062 17.9892 14.0018C18 13.3418 18 12.5983 18 11.75C18 9.85843 17.999 8.49999 17.885 7.44804C17.7725 6.41013 17.5574 5.75992 17.1883 5.25191C16.9262 4.89111 16.6089 4.57382 16.2481 4.31168C15.6482 3.87585 14.8621 3.66092 13.5 3.56725V3.75C13.5 4.16421 13.1642 4.5 12.75 4.5C12.3358 4.5 12 4.16421 12 3.75V3.51079C11.3404 3.50005 10.5976 3.5 9.75 3.5C8.90243 3.5 8.15959 3.50005 7.5 3.51079V3.75C7.5 4.16421 7.16421 4.5 6.75 4.5C6.33579 4.5 6 4.16421 6 3.75V3.56725ZM17.9326 15.5028C17.5276 15.5075 17.2902 15.5199 17.0852 15.5523C15.2666 15.8404 13.8404 17.2666 13.5523 19.0852C13.5199 19.2902 13.5075 19.5276 13.5028 19.9326C14.8631 19.8388 15.6486 19.6238 16.2481 19.1883C16.6089 18.9262 16.9262 18.6089 17.1883 18.2481C17.6239 17.6486 17.8388 16.8631 17.9326 15.5028Z"
        fill="white"
      />
      <path
        d="M5.75 7.75C5.75 8.30228 5.30229 8.75 4.75 8.75C4.19772 8.75 3.75 8.30228 3.75 7.75C3.75 7.19772 4.19772 6.75 4.75 6.75C5.30229 6.75 5.75 7.19772 5.75 7.75Z"
        fill="white"
      />
      <path
        d="M5.75 11.75C5.75 12.3023 5.30229 12.75 4.75 12.75C4.19772 12.75 3.75 12.3023 3.75 11.75C3.75 11.1977 4.19772 10.75 4.75 10.75C5.30229 10.75 5.75 11.1977 5.75 11.75Z"
        fill="white"
      />
      <path
        d="M10.75 7.75C10.75 8.30228 10.3023 8.75 9.75 8.75C9.19772 8.75 8.75 8.30228 8.75 7.75C8.75 7.19772 9.19772 6.75 9.75 6.75C10.3023 6.75 10.75 7.19772 10.75 7.75Z"
        fill="white"
      />
      <path
        d="M10.75 11.75C10.75 12.3023 10.3023 12.75 9.75 12.75C9.19772 12.75 8.75 12.3023 8.75 11.75C8.75 11.1977 9.19772 10.75 9.75 10.75C10.3023 10.75 10.75 11.1977 10.75 11.75Z"
        fill="white"
      />
      <path
        d="M10.75 15.75C10.75 16.3023 10.3023 16.75 9.75 16.75C9.19772 16.75 8.75 16.3023 8.75 15.75C8.75 15.1977 9.19772 14.75 9.75 14.75C10.3023 14.75 10.75 15.1977 10.75 15.75Z"
        fill="white"
      />
      <path
        d="M15.75 7.75C15.75 8.30228 15.3023 8.75 14.75 8.75C14.1977 8.75 13.75 8.30228 13.75 7.75C13.75 7.19772 14.1977 6.75 14.75 6.75C15.3023 6.75 15.75 7.19772 15.75 7.75Z"
        fill="white"
      />
      <path
        d="M15.75 11.75C15.75 12.3023 15.3023 12.75 14.75 12.75C14.1977 12.75 13.75 12.3023 13.75 11.75C13.75 11.1977 14.1977 10.75 14.75 10.75C15.3023 10.75 15.75 11.1977 15.75 11.75Z"
        fill="white"
      />
      <path
        d="M5.75 15.75C5.75 16.3023 5.30229 16.75 4.75 16.75C4.19772 16.75 3.75 16.3023 3.75 15.75C3.75 15.1977 4.19772 14.75 4.75 14.75C5.30229 14.75 5.75 15.1977 5.75 15.75Z"
        fill="white"
      />
    </svg>
  );

  const menuItems = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: dashboardIconSvg,
      key: "Dashboard",
    },
    { name: "Trials Hub", href: "/trials", icon: trialIconSvg, key: "Trials" },
    {
      name: "Patients",
      href: "/patients",
      icon: patientIconSvg,
      key: "Patients",
    },
    {
      name: "Calendar",
      href: "/calendar",
      icon: calendarIconSvg,
      key: "Calendar",
    },
    {
      name: "Conversations",
      href: "/conversation-list",
      icon: conversationIconSvg,
      key: "Conversation-list",
    },
    {
      name: "Integrations",
      href: "/integrations",
      icon: integrationsIconSvg,
      key: "Integrations",
    },
    // { name: "Admin",  icon: adminSvgIcon,
    //   submenu: [
    //     { name: "Locations", href: "/locations", icon: locationIconSvg },
    //     { name: "Recruiters", href: "/recruiters", icon: recruiterIconSvg },
    //   ]
    // },
  ];

  const handleMouseEnter = (index) => {
    setTooltipVisibility((prev) => ({ ...prev, [index]: true }));
  };

  const handleMouseLeave = (index) => {
    setTooltipVisibility((prev) => ({ ...prev, [index]: false }));
  };

  const [tv, setTv] = useState([false, false]);

  function minmizeCall() {
    if (callView.isMaxView) {
      const payload = { isMaxView: false, isMinView: true };
      dispatch(setViewData(payload));
    }
  }

  useEffect(() => {
    if (userProfile.userID && role) {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(
          `${ENDPOINTS.NOTIFICATION.CONNECTION}=${userProfile.userID}&role=${role}`
        )
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      connection
        .start()
        .then(() => {
          console.log("SignalR Connected to SignalR");
          connection.on("notification", (message) => {
            dispatch(fetchUnreadCount());
            setShowNotify(true);
          });
        })
        .catch((err) => console.error("SignalR Connection Error:", err));
    }
  }, [userProfile.userID]);

  useEffect(() => {
    if (showNotify) {
      if (counts?.allCount > 0) {
        setNotifyMessage({
          message: `You have ${counts?.allCount} new notifications.`,
          type: "info",
        });
        setShowNotify(false);
      } else {
        setNotifyMessage({
          message: "",
          type: "",
        });
        setShowNotify(false);
      }
    }
  }, [counts]);

  const onToastClose = () => {
    setNotifyMessage({ message: "", type: "" });
  };

  return (
    <>
      {notifyMessage && notifyMessage.message && (
        <NotificationToast toast={notifyMessage} onClose={onToastClose} />
      )}
      <div
        className={`relative top-0 left-0 h-screen transition-all duration-300 ease-in bg-sidebar_bg z-20 ${
          showSidebar ? "w-64" : "w-16"
        }`}
      >
        <button
          className={`absolute -right-3.5 top-[64px] transition-all duration-300 ease-in ${
            showSidebar ? "" : "rotate-180"
          }`}
          onClick={() => {
            setShowSidebar(!showSidebar);
            setShowSubmenu(false);
            // minimizeCall();
          }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="15"
              cy="15"
              r="14.25"
              fill="white"
              stroke="#245CEA"
              strokeWidth="1.5"
            />
            <path
              d="M18 9L12 15L18 21"
              stroke="#245CEA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div
          className={`flex items-center pt-5 transition-all duration-300 ease-in-out ${
            showSidebar ? "px-5 w-full" : "justify-center px-3 ml-2"
          }`}
        >
          <img
            src={showSidebar ? EpicImg : EpicImgSm}
            className={`h-10 w-10 object-contain object-center ${
              showSidebar ? "px-2 w-full" : "w-10"
            }`}
          />
          {/* <span
            className={`text-white text-xl pl-3 font-mont font-[700] text-[19px] overflow-hidden whitespace-nowrap transition-all duration-500 ease-in-out ${showSidebar ? "opacity-100 max-w-[200px]" : "opacity-0 max-w-0"
              }`}
          >
            EPIC Health
          </span> */}
        </div>
        <div className="pt-5 pb-5 overflow-x-hidden">
          <svg
            width="260"
            height="2"
            viewBox="0 0 260 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="260"
              height="1.5"
              fill="url(#paint0_linear_15345_18824)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_15345_18824"
                x1="0"
                y1="0.75"
                x2="260"
                y2="0.75"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#7A0DB4" stopOpacity="0" />
                <stop offset="0.485" stopColor="white" />
                <stop offset="1" stopColor="#7A0DB4" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="h-[calc(100vh-102px)]">
          <ul className="h-full flex flex-col">
            {menuItems.map((item, index) => (
              <li
                key={index}
                className={`relative flex items-center py-2.5 px-5 menu_hover_color transition duration-200 font-[500] font-mont ${
                  showSidebar ? "" : "justify-center px-3"
                } ${routeName === item.key.toLowerCase() ? "menu_selected" : ""}
                    `}
                onClick={() => {
                  item.submenu && setShowSubmenu(!showSubmenu);
                  setShowSidebar(false);
                  minimizeCall();
                }}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() => handleMouseLeave(index)}
              >
                {item.name === "Conversations" ? (
                  <ConversationItem
                    item={{
                      name: item.name,
                      href: item.href,
                      icon: item.icon,
                      count: counts?.conversationCount
                        ? counts.conversationCount
                        : 0,
                    }}
                    showSidebar={showSidebar}
                  />
                ) : (
                  <Link
                    to={item.href}
                    className={`pl-1 text-base text-white flex`}
                  >
                    <div className="w-[28px]">{item.icon}</div>
                    <div
                      className={`ml-2 ${
                        showSidebar ? "inline-block" : "hidden"
                      } menu-label`}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {item.name}
                    </div>
                  </Link>
                )}

                {item.submenu && (
                  <div
                    className={`flex flex-wrap items-center py-2.5  pr-7 menu_hover_color transition duration-200 ${
                      showSidebar ? "pl-5" : "justify-center pl-7"
                    }`}
                    onClick={() => {
                      setShowSubmenu(!showSubmenu);
                      minimizeCall();
                    }}
                  >
                    <ul
                      className={`w-full pt-2.5 transition-all duration-300 ease-in ${
                        showSubmenu ? "block" : "hidden"
                      }`}
                    >
                      {item.submenu.map((subitem, subindex) => (
                        <li key={subindex} className="submenu-item">
                          <Link to={subitem.link} className="submenu-link">
                            <div className="w-[28px]">{subitem.icon}</div>
                            <div
                              className={`ml-2 ${
                                showSidebar ? "inline-block" : "hidden"
                              } menu-label min-w-[100px] text-nowrap`}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {subitem.name}
                            </div>
                          </Link>

                          {/* Tooltip */}
                          {!showSidebar && tooltipVisibility[index] && (
                            <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90">
                              <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                              <span className="whitespace-nowrap block min-w-[100px]">
                                {subitem.name}
                              </span>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Tooltip */}
                {!showSidebar && tooltipVisibility[index] && (
                  <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90">
                    <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                    <span className="whitespace-nowrap block">{item.name}</span>
                  </div>
                )}
              </li>
            ))}
            <li>
              <div
                className={`flex flex-wrap items-center py-2.5  pr-7 menu_hover_color transition duration-200 ${
                  showSidebar ? "pl-5" : "justify-center pl-7"
                }`}
                onClick={() => {
                  setShowSubmenu(!showSubmenu);
                  minimizeCall();
                }}
                onMouseEnter={() => {
                  const newVisibility = [false, false]; // Reset all tooltips
                  newVisibility[5] = true; // Show tooltip for 'Recruiters'
                  setTv(newVisibility);
                }}
                onMouseLeave={() => {
                  setTv([false, false]); // Hide all tooltips
                }}
              >
                <span
                  href=""
                  className={`pl-1 text-base text-white flex font-mont`}
                >
                  <div className="w-[28px]">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.93237 5.38642L5.75001 6.11391L5.93237 5.38642ZM9.30692 3.43812L8.58572 3.2323L9.30692 3.43812ZM3.23886 10.0517L3.77771 9.53005L3.23886 10.0517ZM3.23886 13.9483L2.70001 13.4266H2.70001L3.23886 13.9483ZM5.93237 18.6136L6.11472 19.3411L5.93237 18.6136ZM9.30692 20.5619L8.58572 20.7677L9.30692 20.5619ZM14.6939 20.5619L15.4151 20.7677L14.6939 20.5619ZM18.0685 18.6136L18.2509 17.8861L18.0685 18.6136ZM20.762 13.9483L20.2232 14.47V14.47L20.762 13.9483ZM20.762 10.0517L20.2232 9.53005V9.53005L20.762 10.0517ZM18.0685 5.38642L17.8861 4.65893L18.0685 5.38642ZM14.6939 3.43812L15.4151 3.2323L14.6939 3.43812ZM5.75001 6.11391C7.60892 6.57987 9.50221 5.48678 10.0281 3.64394L8.58572 3.2323C8.28195 4.2967 7.18841 4.92806 6.11472 4.65893L5.75001 6.11391ZM3.77771 9.53005C2.34244 8.04752 3.74847 5.6122 5.75001 6.11391L6.11472 4.65893C2.64939 3.7903 0.215087 8.00664 2.70001 10.5734L3.77771 9.53005ZM3.77771 14.47C5.11069 13.0931 5.11069 10.9069 3.77771 9.53005L2.70001 10.5734C3.46993 11.3687 3.46992 12.6314 2.70001 13.4266L3.77771 14.47ZM5.75001 17.8861C3.74847 18.3878 2.34244 15.9525 3.77771 14.47L2.70001 13.4266C0.215086 15.9934 2.64939 20.2097 6.11472 19.3411L5.75001 17.8861ZM10.0281 20.3561C9.50221 18.5133 7.60892 17.4202 5.75001 17.8861L6.11472 19.3411C7.18841 19.072 8.28195 19.7033 8.58572 20.7677L10.0281 20.3561ZM13.9727 20.3561C13.4065 22.3403 10.5944 22.3403 10.0281 20.3561L8.58572 20.7677C9.56613 24.2031 14.4347 24.2031 15.4151 20.7677L13.9727 20.3561ZM18.2509 17.8861C16.3919 17.4202 14.4987 18.5133 13.9727 20.3561L15.4151 20.7677C15.7189 19.7033 16.8125 19.072 17.8861 19.3411L18.2509 17.8861ZM20.2232 14.47C21.6584 15.9525 20.2524 18.3878 18.2509 17.8861L17.8861 19.3411C21.3515 20.2097 23.7858 15.9934 21.3009 13.4266L20.2232 14.47ZM20.2232 9.53005C18.8902 10.9069 18.8902 13.0931 20.2232 14.47L21.3009 13.4266C20.5309 12.6314 20.5309 11.3687 21.3009 10.5734L20.2232 9.53005ZM18.2509 6.11391C20.2524 5.6122 21.6584 8.04752 20.2232 9.53005L21.3009 10.5734C23.7858 8.00664 21.3515 3.7903 17.8861 4.65893L18.2509 6.11391ZM13.9727 3.64394C14.4987 5.48678 16.3919 6.57987 18.2509 6.11391L17.8861 4.65893C16.8125 4.92806 15.7189 4.2967 15.4151 3.2323L13.9727 3.64394ZM15.4151 3.2323C14.4347 -0.203084 9.56613 -0.203083 8.58572 3.2323L10.0281 3.64394C10.5944 1.6597 13.4065 1.6597 13.9727 3.64394L15.4151 3.2323ZM8.25043 12C8.25043 14.0711 9.92937 15.75 12.0004 15.75V14.25C10.7578 14.25 9.75043 13.2427 9.75043 12H8.25043ZM12.0004 15.75C14.0715 15.75 15.7504 14.0711 15.7504 12H14.2504C14.2504 13.2427 13.2431 14.25 12.0004 14.25V15.75ZM15.7504 12C15.7504 9.92895 14.0715 8.25001 12.0004 8.25001V9.75002C13.2431 9.75002 14.2504 10.7574 14.2504 12H15.7504ZM12.0004 8.25001C9.92937 8.25001 8.25043 9.92895 8.25043 12H9.75043C9.75043 10.7574 10.7578 9.75002 12.0004 9.75002V8.25001Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    className={`pl-3  ${
                      showSidebar ? "inline-block" : "hidden"
                    }`}
                  >
                    Admin
                  </div>
                </span>
                <button
                  className={`ml-auto transition-all duration-300 ease-in ${
                    showSubmenu ? "rotate-90" : ""
                  } ${showSidebar ? "inline-block" : "hidden"}`}
                >
                  <svg
                    width="9"
                    height="14"
                    viewBox="0 0 9 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.75 13L7.58333 7L1.75 1"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                {/* Tooltip for Locations */}
                {!showSidebar && tv[5] && (
                  <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90">
                    <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                    Admin
                  </div>
                )}
              </div>
              <ul
                className={`w-full pt-2.5 transition-all duration-300 ease-in ${
                  showSubmenu ? "block" : "hidden"
                }`}
              >
                <li
                  className={`flex items-center py-2.5 pr-5 ${
                    showSidebar ? "pl-10" : "pl-3"
                  }  menu_hover_color transition duration-200 font-[500] font-  ${
                    routeName === "locations" ? "menu_selected" : ""
                  }`}
                  onClick={() => {
                    setShowSidebar(false);
                    minimizeCall();
                  }}
                  onMouseEnter={() => {
                    const newVisibility = [false, false]; // Reset all tooltips
                    newVisibility[0] = true; // Show tooltip for 'Recruiters'
                    setTv(newVisibility);
                  }}
                  onMouseLeave={() => {
                    setTv([false, false]); // Hide all tooltips
                  }}
                >
                  <Link
                    to="/locations"
                    className={`pl-1 text-base text-white flex`}
                  >
                    <div className={`${showSidebar ? "" : "pl-[5px]"}`}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.7808 19.7005L14.1906 19.2377L14.7808 19.7005ZM9.21921 19.7005L8.62903 20.1633L9.21921 19.7005ZM12 22.0055V21.2555V22.0055ZM9 9.25C8.58579 9.25 8.25 9.58579 8.25 10C8.25 10.4142 8.58579 10.75 9 10.75V9.25ZM15 10.75C15.4142 10.75 15.75 10.4142 15.75 10C15.75 9.58579 15.4142 9.25 15 9.25V10.75ZM11.25 13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13H11.25ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM19.25 9.6087C19.25 10.8352 18.6104 12.4764 17.6037 14.256C16.6137 16.0063 15.3342 17.7794 14.1906 19.2377L15.371 20.1633C16.5371 18.6762 17.8672 16.837 18.9094 14.9945C19.9349 13.1814 20.75 11.2494 20.75 9.6087H19.25ZM9.80938 19.2377C8.66578 17.7794 7.38628 16.0063 6.39625 14.256C5.38962 12.4764 4.75 10.8352 4.75 9.6087H3.25C3.25 11.2494 4.06511 13.1814 5.09064 14.9945C6.13277 16.837 7.46288 18.6762 8.62903 20.1633L9.80938 19.2377ZM4.75 9.6087C4.75 5.21571 8.04678 1.75 12 1.75V0.25C7.11666 0.25 3.25 4.49277 3.25 9.6087H4.75ZM12 1.75C15.9532 1.75 19.25 5.21571 19.25 9.6087H20.75C20.75 4.49277 16.8833 0.25 12 0.25V1.75ZM14.1906 19.2377C13.5717 20.027 13.1641 20.5426 12.7992 20.8741C12.4664 21.1764 12.2442 21.2555 12 21.2555V22.7555C12.7291 22.7555 13.2948 22.4504 13.8078 21.9844C14.2886 21.5476 14.7849 20.9107 15.371 20.1633L14.1906 19.2377ZM8.62903 20.1633C9.21511 20.9107 9.71136 21.5476 10.1922 21.9844C10.7052 22.4504 11.2709 22.7555 12 22.7555V21.2555C11.7558 21.2555 11.5336 21.1764 11.2008 20.8741C10.8359 20.5426 10.4283 20.027 9.80938 19.2377L8.62903 20.1633ZM9 10.75H15V9.25H9V10.75ZM12.75 13L12.75 7H11.25L11.25 13H12.75Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div
                      className={`pl-3 ${
                        showSidebar ? "inline-block" : "hidden"
                      }`}
                    >
                      Locations
                    </div>
                  </Link>

                  {/* Tooltip for Locations */}
                  {!showSidebar && tv[0] && (
                    <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90">
                      <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                      Locations
                    </div>
                  )}
                </li>
                <li
                  className={`flex items-center py-2.5 pr-5 ${
                    showSidebar ? "pl-10" : "pl-3"
                  }  menu_hover_color transition duration-200 font-[500]  font-mont${
                    showSidebar ? "" : "justify-center"
                  }  ${routeName === "recruiters" ? "menu_selected" : ""}`}
                  onClick={() => {
                    setShowSidebar(false);
                    minimizeCall();
                  }}
                  onMouseEnter={() => {
                    const newVisibility = [false, false]; // Reset all tooltips
                    newVisibility[1] = true; // Show tooltip for 'Recruiters'
                    setTv(newVisibility);
                  }}
                  onMouseLeave={() => {
                    setTv([false, false]); // Hide all tooltips
                  }}
                >
                  <Link
                    to="/recruiters"
                    className={`pl-1 text-base text-white flex `}
                  >
                    <div className={`${showSidebar ? "" : "pl-[3px]"}`}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 4C9.92893 4 8.25 5.67893 8.25 7.75C8.25 9.82107 9.92893 11.5 12 11.5C14.0711 11.5 15.75 9.82107 15.75 7.75C15.75 5.67893 14.0711 4 12 4ZM9.75 7.75C9.75 6.50736 10.7574 5.5 12 5.5C13.2426 5.5 14.25 6.50736 14.25 7.75C14.25 8.99264 13.2426 10 12 10C10.7574 10 9.75 8.99264 9.75 7.75Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9 13C6.92893 13 5.25 14.6789 5.25 16.75C5.25 18.8211 6.92893 20.5 9 20.5H15C17.0711 20.5 18.75 18.8211 18.75 16.75C18.75 14.6789 17.0711 13 15 13H9ZM6.75 16.75C6.75 15.5074 7.75736 14.5 9 14.5H15C16.2426 14.5 17.25 15.5074 17.25 16.75C17.25 17.9926 16.2426 19 15 19H9C7.75736 19 6.75 17.9926 6.75 16.75Z"
                          fill="white"
                        />
                        <path
                          d="M7.75214 10.3887C7.59441 10.1353 7.29846 10 7 10C5.75736 10 4.75 8.99264 4.75 7.75C4.75 6.50736 5.75736 5.5 7 5.5C7.29846 5.5 7.59441 5.36473 7.75214 5.11135C7.75912 5.10014 7.76613 5.08896 7.7732 5.07782C8.0358 4.66331 7.90275 4.0764 7.415 4.0227C7.27873 4.0077 7.14027 4 7 4C4.92893 4 3.25 5.67893 3.25 7.75C3.25 9.82107 4.92893 11.5 7 11.5C7.14027 11.5 7.27873 11.4923 7.415 11.4773C7.90275 11.4236 8.0358 10.8367 7.7732 10.4222C7.76614 10.411 7.75912 10.3999 7.75214 10.3887Z"
                          fill="white"
                        />
                        <path
                          d="M4.70829 18.3169C4.59477 18.1275 4.39439 18 4.17359 18H4C2.75736 18 1.75 16.9926 1.75 15.75C1.75 14.5074 2.75736 13.5 4 13.5H4.17359C4.39439 13.5 4.59477 13.3725 4.70829 13.1831C4.98539 12.7208 4.68468 12 4.14569 12H4C1.92893 12 0.25 13.6789 0.25 15.75C0.25 17.8211 1.92893 19.5 4 19.5H4.14569C4.68469 19.5 4.98539 18.7792 4.70829 18.3169Z"
                          fill="white"
                        />
                        <path
                          d="M16.2268 10.4222C15.9642 10.8367 16.0973 11.4236 16.585 11.4773C16.7213 11.4923 16.8597 11.5 17 11.5C19.0711 11.5 20.75 9.82107 20.75 7.75C20.75 5.67893 19.0711 4 17 4C16.8597 4 16.7213 4.0077 16.585 4.0227C16.0973 4.0764 15.9642 4.66331 16.2268 5.07782C16.2339 5.08896 16.2409 5.10014 16.2479 5.11134C16.4056 5.36472 16.7015 5.5 17 5.5C18.2426 5.5 19.25 6.50736 19.25 7.75C19.25 8.99264 18.2426 10 17 10C16.7015 10 16.4056 10.1353 16.2479 10.3887C16.2409 10.3999 16.2339 10.411 16.2268 10.4222Z"
                          fill="white"
                        />
                        <path
                          d="M19.2917 18.3169C19.0146 18.7792 19.3153 19.5 19.8543 19.5H20C22.0711 19.5 23.75 17.8211 23.75 15.75C23.75 13.6789 22.0711 12 20 12H19.8543C19.3153 12 19.0146 12.7208 19.2917 13.1831C19.4052 13.3725 19.6056 13.5 19.8264 13.5H20C21.2426 13.5 22.25 14.5074 22.25 15.75C22.25 16.9926 21.2426 18 20 18H19.8264C19.6056 18 19.4052 18.1275 19.2917 18.3169Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div
                      className={`pl-3 ${
                        showSidebar ? "inline-block" : "hidden"
                      }`}
                    >
                      Recruiters
                    </div>
                  </Link>

                  {/* Tooltip for Recruiters */}
                  {!showSidebar && tv[1] && (
                    <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90">
                      <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                      Recruiters
                    </div>
                  )}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Leftbar;
